module.exports = __webpack_public_path__ + "img/12.0d3ee296.jpg";